/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
import "moment-timezone";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import deleteSvg from "../../assets/image/deleteSvg.svg";
import EDIT from "../../assets/image/EDIT.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import CommonewModel from "../commonModel/commonModel";
import DeleteConfirmModal from "../RecipientManagement/DeleteConfirmModal";
import ReusableTable from "../UserInformation/ReusableTable";

const BenefitManagement = () => {
  const { benefitList, ClearFormSet } = useSelector(
    (state) => state.adminReducers
  );
  const [currentPage, setCurrentPage] = useState(1);
  const { websocket } = useContext(WebSocketContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {},
  });
  const [removeModal, setRemoveModal] = useState({
    open: false,
    machine: null,
  });
  const handleRemove = (machine) => {
    setRemoveModal({ open: true, machine });
  };
  const closeRemoveModal = () => {
    setRemoveModal({ open: false, machine: null });
  };
  const confirmRemove = () => {
    let param = {
      transmit: "single",
      url: "benefit_delete",
      request: {
        benefit_id: removeModal?.machine?.id,
      },
    };
    wsSend_request(websocket, param);
    setRemoveModal({ open: false, machine: null });
    callFaqList();
  };

  function callFaqList() {
    let param = {
      transmit: "single",
      url: "benefit_list",
      request: {
        limit: "20",
        page_no: currentPage,
      },
    };
    wsSend_request(websocket, param);
  }

  useEffect(() => {
    callFaqList();
  }, [websocket, currentPage]);

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (ClearFormSet?.url === "benefit_edit" && ClearFormSet?.action === 200) {
      callFaqList();
    }
    setTimeout(() => {
      dispatch(
        ClearFormSetFutios({
          url: "",
          action: "",
        })
      );
    }, 1000);
  }, [ClearFormSet, dispatch]);

  useEffect(() => {
    if (
      ClearFormSet?.url === "benefit_delete" &&
      ClearFormSet?.action === 200
    ) {
      callFaqList();
    }
    setTimeout(() => {
      dispatch(
        ClearFormSetFutios({
          url: "",
          action: "",
        })
      );
    }, 1000);
  }, [ClearFormSet, dispatch]);

  function htmlToText(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  }
  const headers = [
    { name: "Question", key: "question" },
    { name: "Answer", key: "answer" },
    { name: "Action", key: "action" },
  ];

  const renderRow = (faq, index,visibleColumns) => {
    return (
      <React.Fragment key={faq?.id}>
        <tr key={faq.id} className="user-management-table-detail">
        {visibleColumns?.includes("question")&&(
          <td style={{ cursor: "default" }} className="Vertical_align">{faq.question}</td>
        )}
        {visibleColumns?.includes("answer")&&(
          <td className="Vertical_align">
            <form action="">
              <textarea
                defaultValue={htmlToText(faq.answer)}
                readOnly
                className="answer_div"
              ></textarea>
            </form>
          </td>
        )}
        {visibleColumns?.includes("action")&&(
          <td style={{ cursor: "default" }} className="Vertical_align">
            <div className="d-flex gap-2">
              <span
                className="detail-icon"
                onClick={() => navigate("/edit-benefit/" + faq.id)}
              >
                <img src={EDIT} alt="edit" title="Edit" />
              </span>
              <span className="detail-icon" onClick={() => handleRemove(faq)}>
                <img src={deleteSvg} alt="edit" title="Edit" />
              </span>
            </div>
          </td>
        )}
        </tr>
      </React.Fragment>
    );
  };
  return (
    <>
      <div style={{ margin: "2px" }} className="fixTableHead">
        <ReusableTable
          headers={headers}
          data={benefitList?.list || []}
          paginationObject={benefitList?.pagination}
          renderRow={renderRow}
          filters={{
            fromDate: false,
            toDate: false,
            period: false,
            search: false,
            searchPlaceholder: "Search by",
            userSelect: false,
            userOptions: [],
            export: false,
            isAdd: true,
            isAddtitle: "Add Benefit",
            isAddLink: "/add-benefit",
          }}
          currentPage={currentPage}
          handlePageChange={currentFunction}
        />
      </div>
      {showModalNew?.open && (
        <CommonewModel
          setShowModalNew={setShowModalNew}
          showModalNew={showModalNew}
        />
      )}
      {removeModal.open && (
        <DeleteConfirmModal
          open={removeModal.open}
          onClose={closeRemoveModal}
          onConfirm={confirmRemove}
          message="Are you sure you want to Delete this Benefit?"
        />
      )}
    </>
  );
};

export default BenefitManagement;
